import Vue from 'vue';
import LoadingToast from './index.hippy.vue';

export default LoadingToast;

// 找到根节点
function findRootNode(node) {
  let root = node;
  while (root && root.parentNode) {
    root = root.parentNode;
  }
  return root;
}

let instance; // loading组件实例
let rootNode; // 页面根节点
let loadingCount = 0; // 用来记录当前调用loading的次数。当多次调用，只有变成0的时候才关闭

/**
 * 关闭loading弹窗
 */
export function closeLoadingToast() {
  if (loadingCount > 0) {
    loadingCount -= 1;
  }
  if (instance && rootNode && loadingCount === 0) {
    instance.stop();
    instance.$destroy();
    rootNode.removeChild(instance.$el);
  }
}

/**
 * 打开loading弹窗
 * @param {VueInstance} vm 当前页面vue实例
 * @param {Number} duration 时间间隔
 * @returns {Function} closeLoadingFunction 关闭弹窗
 *
 * @example
 * ```
 * const closeLoading = this.tools.showLoadingToast();
 * setTimeout(closeLoading, 5000);
 * ```
 */
export function showLoadingToast(vm) {
  // 重复调用loading
  if (loadingCount > 0) {
    loadingCount += 1;
    return closeLoadingToast;
  }
  loadingCount += 1;
  const Comp = Vue.extend(LoadingToast);
  instance = new Comp();
  instance.$mount();
  rootNode = findRootNode(vm.$el);
  rootNode.appendChild(instance.$el);
  instance.play();
  return closeLoadingToast;
}
